import gsap from 'gsap';
import ScrollTriggerController from "./scroll-trigger_controller";

export default class FooterAnimateController extends ScrollTriggerController {

    static values = {
        fromOpacity: { type: Number, default: 0 },
        toOpacity:   { type: Number, default: 1 },
        fromY:       { type: Number, default: 150 },
        toY:         { type: Number, default: 0 },
        ease:        { type: String, default: 'none' },
        start:       { type: String, default: 'top 30%' },
        end:         { type: String, default: 'top 0%' },
        scrub:       { type: Number, default: 1 },
    };

    ctx;

    connect() {
        this.ctx = gsap.context(() => {
            gsap.fromTo(this.element,
                {
                    opacity: this.fromOpacityValue,
                    y:       this.fromYValue,
                },
                {
                    opacity: this.toOpacityValue,
                    y:       this.toYValue,
                    ease:    this.easeValue,

                    scrollTrigger: {
                        trigger: this.element,
                        start:   this.startValue,
                        end:     this.endValue,
                        scrub:   this.scrubValue,
                    },
                }
            );
        }, this.element);
    }

    disconnect() {
        this.ctx?.revert();
        this.ctx = null;
    }
}
